// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"643":"87bed5c5","769":"399cd722","825":"87bed5c5"}[chunkId] + ".chunk.css";
};